import React from 'react';
import styled from 'styled-components';
import { useGetTranslatedSectionName } from '../../../../layouts/Section/hooks';

const FallbackContainer = styled.div`
  padding: 8px 12px;
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 6px;
  text-align: center;
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: 8px;
`;

const RetryButton = styled.button`
  background: transparent;
  color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.primary};
    color: white;
  }
`;

interface JackpotFallbackProps {
  jackpotName: string;
  error?: Error;
  onRetry?: () => void;
}

export const JackpotFallback: React.FC<JackpotFallbackProps> = ({ jackpotName, error: _error, onRetry }) => {
  const sectionName = useGetTranslatedSectionName(jackpotName);

  return (
    <FallbackContainer>
      <ErrorMessage>{sectionName} panel temporarily unavailable</ErrorMessage>
      {onRetry && <RetryButton onClick={onRetry}>Retry</RetryButton>}
    </FallbackContainer>
  );
};
